import { Common } from '@sv-support-sdk/shared-types';

type TSorting = Common.HelpCenter.IHelpCenterCategory | Common.HelpCenter.IHelpCenterTopic;

const topicsSorting = (a: TSorting, b: TSorting) => {
  if (a.sort !== b.sort) return a.sort - b.sort;

  const nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();

  return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : b.id - a.id;
}

export { topicsSorting };
